<div class="app-modal-spinner">
  <app-modal-header (onCloseChange)="onClose()"></app-modal-header>
  <p>ログインする事業所を選択してください</p>
  <ul *ngIf="unitList$ | async as unitList" class="link-list">
    <li *ngFor="let unit of unitList">
      <button mat-button class="next-button" (click)="selectUnit(unit)">
        {{ unit.companyName }}<br />{{ unit.blockName }}<br />{{ unit.name }}
      </button>
    </li>
  </ul>
  <app-modal-footer
    cancelText="閉じる"
    (onCloseChange)="onClose()"
  ></app-modal-footer>
</div>
